import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingSelectedOffering = createSelector(
  [selectLandingState],
  ({ selectedOffering }) => selectedOffering
)
